/**
 * Public web origin for admin "View on web" deep-links (Pre-launch Area 9). Single source of
 * truth — defaults to the production custom domain, never a *.pages.dev test host.
 */
export const WEB_URL = import.meta.env.VITE_WEB_URL || "https://ckgo2.com";
